function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/pro-regular-svg-icons";
import _ from "lodash";
import { Button } from "./Buttons";
import styled from "styled-components";
const StyledLink = styled(Link)`
  padding-left: .8rem;
`;

class LinkNewButton extends React.Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "render", () => {
      return /*#__PURE__*/React.createElement(StyledLink, {
        to: this.props.path,
        className: "action-icon"
      }, ' ', /*#__PURE__*/React.createElement(Button, {
        color: 'info',
        size: 'sm',
        type: "button",
        cypress: this.props.cypress
      }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
        icon: faPlus
      }), " ", `${_.startCase(this.props.name)}`));
    });
  }

}

export default LinkNewButton;